import { useState, useEffect } from 'react';

const EQUAL_HEIGHT_DIFF = 3;
const useEllipsisDetection = function (ref) {
  var _ref$current, _ref$current2, _ref$current3, _ref$current4;
  let externalDependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const [isTruncated, setIsTruncated] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (!ref.current) return;
      const {
        scrollWidth,
        clientWidth,
        scrollHeight,
        clientHeight
      } = ref.current;
      setIsTruncated(scrollWidth > clientWidth || scrollHeight > clientHeight + EQUAL_HEIGHT_DIFF);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [ref, ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollWidth, ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.clientWidth, ref === null || ref === void 0 ? void 0 : (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.scrollHeight, ref === null || ref === void 0 ? void 0 : (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.clientHeight, ...externalDependencies]);
  return isTruncated;
};

export { useEllipsisDetection as default };
